import type {
  HierarchicalRulesetConfigField,
  ModifiedNumberField,
  NumberField,
  ValueType
} from '@library/types/rulesets';
import { LineupLimitsInput } from '@bo-components/rulesets/lineupLimits/LineupLimitsInput';
import { RulesetsContext } from '@bo-hooks/rulesets/useRulesetsContext';
import { useContext } from 'react';

const lineupLimitsFields: Array<{
  label: string;
  fieldName: HierarchicalRulesetConfigField;
}> = [
  {
    label: 'Maximum lineup amount',
    fieldName: 'max_lineup_amount'
  },
  {
    label: 'Minimum lineup amount',
    fieldName: 'min_lineup_amount'
  },
  {
    label: 'Maximum amount won',
    fieldName: 'max_amount_won'
  },
  {
    label: 'Maximum daily lineup amount',
    fieldName: 'max_daily_lineup_amount'
  },
  {
    label: 'Flash promo max',
    fieldName: 'flash_promo_max'
  },
  {
    label: 'Max liability per pick',
    fieldName: 'max_liability_per_pick'
  },
  {
    label: 'Daily promo limit',
    fieldName: 'daily_promo_limit'
  },
  {
    label: 'In game multiplier limit',
    fieldName: 'in_game_multiplier'
  },
  {
    label: 'Refund within minutes',
    fieldName: 'refund_in_minutes'
  }
];

export const LineupLimits = () => {
  const {
    currentRuleset,
    modifiedFields,
    handleUpdateRulesetField,
    matchedAllowedRules,
    matchedAllowedRuleTypes,
    isPreviewLoading
  } = useContext(RulesetsContext);

  return (
    <div className="bg-soFresh-110 text-soClean-160 font-heebo flex h-fit w-1/2 flex-col gap-4 rounded-md p-5">
      <span className="text-soClean-100 font-heebo text-lg">Lineup Limits</span>

      {currentRuleset && matchedAllowedRules.size > 0 && (
        <>
          {lineupLimitsFields.map((field) =>
            matchedAllowedRules.has(field.fieldName) ? (
              <LineupLimitsInput
                fieldName={field.fieldName}
                inputLabel={field.label}
                initialValue={
                  currentRuleset.attributes[field.fieldName] as NumberField
                }
                modifiedValue={
                  modifiedFields[field.fieldName] as ModifiedNumberField
                }
                allowedTypes={
                  matchedAllowedRuleTypes[field.fieldName] as ValueType[]
                }
                handleUpdateRulesetField={handleUpdateRulesetField}
                key={field.fieldName}
                disabled={isPreviewLoading}
              />
            ) : null
          )}
        </>
      )}

      {!currentRuleset && <>Unable to load ruleset</>}
    </div>
  );
};
